import { Avatar } from '@mantine/core';

import { accent } from '../theme';

/** A child's initial, in their mode's colour. There are no photographs of
 * children in this product, and this is the reason there never need to be. */
export function ChildAvatar({ name, mode, size = 54 }: { name: string; mode: string; size?: number }) {
  const a = accent(mode);
  return (
    <Avatar size={size} radius="xl" variant="filled" color={a.color} fz={size / 2.4} fw={600}>
      {name.trim().charAt(0).toUpperCase() || '?'}
    </Avatar>
  );
}
